import { TrashIcon } from 'lucide-react'

import { Skeleton } from '@/components'
import { Button, CopyButton } from '@/components/ui'
import { useInvitations, useLoadingInvitations } from '@/modules/account'
import { useDialogActions } from '@/stores'
import {
  cn,
  formatDate,
  getInvitationPath,
  getUrl,
  humanizeDate,
} from '@/utils'
import { RevokeInvitationDialog } from './dialogs/RevokeInvitationDialog'

export const PendingInvitations = () => {
  const invitations = useInvitations()
  const loading = useLoadingInvitations()
  const { openDialog } = useDialogActions()

  if (loading) {
    return (
      <div className="space-y-3">
        <Skeleton className="h-12 w-full" />
      </div>
    )
  }

  if (invitations.length === 0) {
    return (
      <p className="text-sm text-muted-foreground">No pending invitations.</p>
    )
  }

  return (
    <>
      <div className="divide-y rounded-md border">
        {invitations.map((invitation) => (
          <div
            key={invitation.id}
            className={cn(
              'flex items-center justify-between px-4 py-3',
              invitation.hasExpired && 'bg-muted',
            )}
          >
            <div className="flex flex-col gap-0.5">
              <span className="text-sm">{invitation.email}</span>
              <span className="text-xs text-muted-foreground">
                {invitation.hasExpired ? 'Expired at' : 'Expires'}{' '}
                {humanizeDate(invitation.expiresAt)}
              </span>
            </div>
            <div className="flex items-center gap-1">
              {!invitation.hasExpired && (
                <CopyButton
                  size="xs"
                  theme="ghost"
                  text={getUrl(getInvitationPath(invitation))}
                />
              )}
              <Button
                size="xs"
                theme="ghost"
                isIcon
                onClick={() =>
                  openDialog(RevokeInvitationDialog.id, invitation)
                }
              >
                <TrashIcon className="size-4" />
              </Button>
            </div>
          </div>
        ))}
      </div>
      <RevokeInvitationDialog />
    </>
  )
}
